import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components';

import News_Item from '../News_Item';
import Container from '../Shared/Container';
import InnerContainer from '../Shared/InnerContainer';
import SectionHeader from '../Shared/SectionHeader';
import SectionLink from '../Shared/SectionLink';

var marked = require('marked');

const News_Section = (props) => (
  <Container >
    <InnerContainer>
      <SectionHeader>News and Updates</SectionHeader>
      <News_Item news={props.news[0].node} />
      <News_Item news={props.news[1].node} />
      <News_Item news={props.news[2].node} />
      <SectionLink to="/news/"> See More </SectionLink>
    </InnerContainer>
  </Container>
);

export default News_Section;



// WEBPACK FOOTER //
// ./src/components/News_Section/index.js